import { type ReactNode } from 'react'
import { useSearchParams } from 'react-router'
import OrgConsoleRedirect from './OrgConsoleRedirect'

/**
 * Staff safety tools that Filament still iframes with `?embed=1`.
 * Non-embed visits get a chooser (not an auto-redirect to Lumen login).
 */
export default function OrgStaffToolGate({ children }: { children: ReactNode }) {
  const [params] = useSearchParams()
  const embedParam = params.get('embed') === '1'
  const framed = typeof window !== 'undefined' && window.self !== window.top

  if (embedParam || framed) {
    return children
  }

  return <OrgConsoleRedirect />
}
